import { render } from "./Rules.vue?vue&type=template&id=6df2fd4c"
import script from "./Rules.vue?vue&type=script&lang=js"
export * from "./Rules.vue?vue&type=script&lang=js"

import "./Rules.vue?vue&type=style&index=0&id=6df2fd4c&lang=scss"
script.render = render

export default script